import Icon from "../commons/Icon";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import CismetFooterAcks from "./wuppertal/CismetFooterAcknowledgements";
import GenericRVRStadtplanwerkMenuFooter from "./wuppertal/GenericRVRStadtplanwerkMenuFooter";
import { UIContext, UIDispatchContext } from "../contexts/UIContextProvider";
import { ResponsiveTopicMapContext } from "../contexts/ResponsiveTopicMapContextProvider";

const Comp = ({
  visible,
  uiHeight,
  setVisibleState,
  modalBodyStyle,
  title,
  titleIconName,
  mainSection,
  subSections,
  imageUrl,
  imageStyle,
  footer = (
    <div>
      <span style={{ fontSize: "11px" }}>
        <CismetFooterAcks />
      </span>
    </div>
  ),
  defaultContextValues = {},
  menuIcon = "bars",
  menuTitle = "Einstellungen und Hilfe",
  menuSections = [],
  menuFooter = <GenericRVRStadtplanwerkMenuFooter />,
}) => {
  const { secondaryInfoVisible } = useContext(UIContext) || defaultContextValues;
  const { setSecondaryInfoVisible } = useContext(UIDispatchContext) || defaultContextValues;
  const { windowSize } = useContext(ResponsiveTopicMapContext) || defaultContextValues;
  let _visible, _setVisibleState;

  if (visible === undefined) {
    _visible = secondaryInfoVisible;
  } else {
    _visible = visible;
  }

  if (setVisibleState === undefined) {
    _setVisibleState = setSecondaryInfoVisible;
  } else {
    _setVisibleState = setVisibleState;
  }
  const close = () => {
    _setVisibleState(false);
  };
  if (modalBodyStyle === undefined) {
    modalBodyStyle = {
      overflowY: "auto",
      overflowX: "hidden",
      maxHeight: (uiHeight || windowSize.height) - 200,
    };
  }

  return (
    <Modal
      style={{
        zIndex: 10000000,
      }}
      height="100%"
      size="xl"
      show={_visible}
      onHide={close}
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>
          {titleIconName !== undefined && <Icon name={titleIconName} />} {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={modalBodyStyle} id="myMenu">
        <div style={{ width: "100%", minHeight: undefined }}>
          {imageUrl !== undefined && (
            <img
              alt="Bild"
              style={
                imageStyle || {
                  paddingLeft: 10,
                  paddingRight: 10,
                  float: "right",
                  paddingBottom: "5px",
                }
              }
              src={imageUrl}
              width="250"
            />
          )}
          {mainSection}
        </div>
        {subSections || []}
      </Modal.Body>
      <Modal.Footer>
        <table
          style={{
            width: "100%",
          }}
        >
          <tbody>
            <tr>
              <td
                style={{
                  textAlign: "left",
                  verticalAlign: "bottom",
                  paddingRight: "30px",
                }}
              >
                {footer}
              </td>
              <td>
                <Button
                  id="cmdCloseModalApplicationMenu"
                  bsStyle="primary"
                  type="submit"
                  onClick={close}
                >
                  Ok
                </Button>
              </td>
            </tr>
          </tbody>
        </table>
      </Modal.Footer>
    </Modal>
  );
};

export default Comp;
Comp.propTypes = {
  visible: PropTypes.bool,
  uiHeight: PropTypes.number,
  setVisibleState: PropTypes.func,
  modalBodyStyle: PropTypes.object,
  title: PropTypes.string,
  titleIconName: PropTypes.string,
  mainSection: PropTypes.node,
  subSections: PropTypes.array,
  imageUrl: PropTypes.string,
  imageStyle: PropTypes.object,
  footer: PropTypes.node,
  menuIcon: PropTypes.string,
  menuTitle: PropTypes.string,
  menuSections: PropTypes.array,
  menuFooter: PropTypes.node,

  uiStateActions: PropTypes.object,
  uiState: PropTypes.object,
  kitasState: PropTypes.object,
  kitasActions: PropTypes.object,
  mappingState: PropTypes.object,
  mappingActions: PropTypes.object,
};
